export class ServicioFuncionarioModel {

    public idServicioFuncionario: string;
    public tramite: string;
    public fechaIncialAtencion: Date;
    public fechaFinalAtencion: Date;
    public numeroVentanilla: string;
    public sede: string;
    public tipoIdFuncAtendido: string;
    public numeroIdFunAtendido: string;
    public tipoIdFuncionario: string;
    public numeroIdFuncionario: string;

    constructor(idServicioFuncionario, tramite, fechaIncialAtencion
        , fechaFinalAtencion, numeroVentanilla, sede, tipoIdFuncAtendido, numeroIdFunAtendido
        , tipoIdFuncionario, numeroIdFuncionario) {

        this.idServicioFuncionario = idServicioFuncionario;
        this.tramite = tramite;
        this.fechaIncialAtencion = fechaIncialAtencion;
        this.fechaFinalAtencion = fechaFinalAtencion;
        this.numeroVentanilla = numeroVentanilla;
        this.sede = sede;
        this.tipoIdFuncAtendido = tipoIdFuncAtendido;
        this.numeroIdFunAtendido = numeroIdFunAtendido;
        this.tipoIdFuncionario = tipoIdFuncionario;
        this.numeroIdFuncionario = numeroIdFuncionario;
    }

}